/**
 * Utility function to validate ISBN-10 and ISBN-13 formats and checksums.
 */
export function validateIsbn(isbn: string): { isValid: boolean; format?: 'ISBN-10' | 'ISBN-13'; error?: string } {
  // If empty, it's optional, so we consider it valid
  if (!isbn || !isbn.trim()) {
    return { isValid: true };
  }

  // Clean characters except digits and X/x
  const clean = isbn.replace(/[- ]/g, '').toUpperCase();

  // Validate character set: must only contain digits, and optionally end with X for 10-digit
  if (!/^[0-9X]+$/.test(clean)) {
    return { isValid: false, error: 'Hanya boleh berisi angka, tanda hubung, atau spasi (X hanya boleh di akhir)' };
  }

  if (clean.length === 10) {
    // Validate ISBN-10 checksum
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      const char = clean[i];
      if (char === 'X') {
        return { isValid: false, format: 'ISBN-10', error: 'Karakter "X" hanya diperbolehkan pada digit terakhir' };
      }
      sum += (10 - i) * parseInt(char, 10);
    }
    
    const lastChar = clean[9];
    const lastDigit = lastChar === 'X' ? 10 : parseInt(lastChar, 10);
    if (isNaN(lastDigit)) {
      return { isValid: false, format: 'ISBN-10', error: 'Karakter tidak valid' };
    }
    sum += lastDigit;

    if (sum % 11 === 0) {
      return { isValid: true, format: 'ISBN-10' };
    } else {
      return { isValid: false, format: 'ISBN-10', error: 'Angka pemeriksaan (checksum) ISBN-10 tidak valid' };
    }
  } else if (clean.length === 13) {
    // Validate ISBN-13 checksum
    if (clean.includes('X')) {
      return { isValid: false, format: 'ISBN-13', error: 'Karakter "X" tidak diperbolehkan dalam ISBN-13' };
    }

    let sum = 0;
    for (let i = 0; i < 13; i++) {
      const digit = parseInt(clean[i], 10);
      if (isNaN(digit)) {
        return { isValid: false, format: 'ISBN-13', error: 'Karakter tidak valid' };
      }
      sum += (i % 2 === 0) ? digit : digit * 3;
    }

    if (sum % 10 === 0) {
      return { isValid: true, format: 'ISBN-13' };
    } else {
      return { isValid: false, format: 'ISBN-13', error: 'Angka pemeriksaan (checksum) ISBN-13 tidak valid' };
    }
  } else {
    return { isValid: false, error: 'Panjang ISBN harus berupa 10 digit (ISBN-10) atau 13 digit (ISBN-13)' };
  }
}
